import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ErrorsService {
	isInvoiceError = new BehaviorSubject(false);

	// Notify
	notifyError() {
		this.isInvoiceError.next(true);
	}
}
